import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { Component, useState } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { panelTextInput } from '@atlaskit/editor-common/ui';
// eslint-disable-next-line @repo/internal/react/no-class-components
export var InputOld = /*#__PURE__*/function (_Component) {
  function InputOld(props) {
    var _this;
    _classCallCheck(this, InputOld);
    _this = _callSuper(this, InputOld, [props]);
    _defineProperty(_this, "handleChange", function (e) {
      _this.setState({
        text: e.target.value
      });
    });
    _defineProperty(_this, "handleSubmit", function (e) {
      e.preventDefault();
      if (_this.props.onSubmit) {
        _this.props.onSubmit(_this.state.text);
      }
    });
    _defineProperty(_this, "handleBlur", function (e) {
      e.preventDefault();
      if (_this.props.onBlur) {
        _this.props.onBlur(_this.state.text);
      }
    });
    _this.state = {
      text: props.defaultValue || ''
    };
    return _this;
  }

  // Ignored via go/ees005
  // eslint-disable-next-line react/no-unsafe
  _inherits(InputOld, _Component);
  return _createClass(InputOld, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.state.text !== nextProps.defaultValue) {
        this.setState({
          text: nextProps.defaultValue || ''
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var placeholder = this.props.placeholder;
      return jsx("form", {
        onSubmit: this.handleSubmit
      }, jsx("input", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: panelTextInput,
        value: this.state.text,
        onChange: this.handleChange,
        placeholder: placeholder,
        onBlur: this.handleBlur
      }));
    }
  }]);
}(Component);
export var InputNew = function InputNew(props) {
  var defaultValue = props.defaultValue,
    onBlur = props.onBlur,
    onSubmit = props.onSubmit,
    placeholder = props.placeholder;
  var _useState = useState(defaultValue || ''),
    _useState2 = _slicedToArray(_useState, 2),
    text = _useState2[0],
    setText = _useState2[1];
  var handleChange = function handleChange(e) {
    setText(e.target.value);
  };
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    onSubmit && onSubmit(text);
  };
  var handleBlur = function handleBlur(e) {
    e.preventDefault();
    onBlur && onBlur(text);
  };
  return jsx("form", {
    onSubmit: handleSubmit
  }, jsx("input", {
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    css: panelTextInput,
    value: text,
    onChange: handleChange,
    placeholder: placeholder,
    onBlur: handleBlur
  }));
};